package com.appsyde.shared.network.exception


class NotAuthenticatedException(message: String) : Exception(message)
class InsufficientScopesException(message: String) : Exception(message)

class RemoteApiException(
    val code: String,
    override val message: String?,
    val requestId: String? = null,
    val fields: Map<String, String>? = null,
    val httpStatus: Int? = null,
    val rawBody: String? = null
) : Exception(message)